<template>
    <div>
        <div class="uk-flex uk-flex-column uk-flex-middle">
            <!-- 입력부 -->
            <div class="w-50rem">
                <!-- 입력 예시 -->
                <div class="font-size-1d25rem">
                    이름/핸드폰/우편번호(5자리)/개인통관고유부호/(옵션)영문이름/(옵션)영문성
                </div>

                <div class="">
                    <textarea class="w-full h-25rem font-size-1d125rem" placeholder="이름/핸드폰/우편번호(5자리)/개인통관고유부호/(옵션)영문이름/(옵션)영문성" :disabled="state !== 'ready'" v-model="inputText"></textarea>
                </div>

                <div class="">
                    <button v-show="state === 'ready'" class="uk-button uk-button-primary w-full" type="button" @click="check">
                        <i class="material-icons">check</i>
                        검사
                    </button>

                    <div v-show="state === 'exec'" class="uk-text-danger uk-text-bold">
                        처리중입니다...잠시만 기다려주세요...
                    </div>

                    <button v-show="state === 'done'" class="uk-button uk-button-primary w-full" type="button" @click="retry">
                        <i class="material-icons">replay</i>
                        다시 입력
                    </button>
                </div>


            </div>

            <!-- 결과부 -->
            <div v-show="state !== 'ready'" class="uk-width-auto mt-2rem">



                <!-- 최종결과 -->
                <div class="total-has-no-item" v-show="totalState.result === 'has-no-item'">
                    <i class="material-icons">info</i>
                    검사가능한 정보가 존재하지 않습니다.
                </div>
                <div class="total-correct" v-show="totalState.result === 'correct'">
                    <i class="material-icons">done</i>
                    모두 일치합니다.
                </div>
                <div class="total-has-incorrect" v-show="totalState.result === 'has-incorrect'">
                    <i class="material-icons">error</i>
                    총 {{ totalState.incorrect_count }}건이 불일치합니다. <br />
                    개인통관고유부호를 다시 한번 확인하세요.
                </div>

                <table class="uk-table uk-table-divider uk-background-default border-box">
                    <colgroup>
                        <col style="width: 10rem">
                        <col style="width: 10rem">
                        <col style="width: 8rem">
                        <col style="width: 12rem">
                        <col style="width: 10rem">
                        <col style="width: 10rem">
                        <col style="width: 6rem">
                        <col >
                    </colgroup>
                    <thead>
                    <tr>
                        <th class="uk-text-center">이름</th>
                        <th class="uk-text-center">핸드폰</th>
                        <th class="uk-text-center">우편번호</th>
                        <th class="uk-text-center">개인통관고유부호</th>
                        <th class="uk-text-center">영문이름</th>
                        <th class="uk-text-center">영문성</th>
                        <th class="uk-text-center">결과</th>
                        <th class="uk-text-center">상세사유</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        :class="obj.api_state"
                        v-for="(obj, index) in inputs"
                        :key="index"
                    >
                        <td>{{ obj.name }}</td>
                        <td>{{ obj.cell }}</td>
                        <td>{{ obj.zipcode }}</td>
                        <td>{{ obj.clearance_no }}</td>
                        <td>{{ obj.first_name }}</td>
                        <td>{{ obj.last_name }}</td>
                        <td class="result">{{ getApiStateText(obj) }}</td>
                        <td>{{ obj.fail_msg }}</td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="uk-margin-top" v-show="state === 'ready'">
            <div>
                사용법 ) 이름과 개인통관고유부호를 <b>슬래시 /</b>로 구분하여 여러건을 입력하세요. <br /><br />
                * 슬래시대신 컴마, 스페이스, 탭 등의 기호를 사용하여 구분할 수 있습니다.<br /><br />
                ** 핸드폰번호는 대시(-) 없이 숫자만으로 총 11자리 입력해야 합니다.<br /><br />
                *** 영문이름/영문성은 수취인명이 영어인 경우에만 필요합니다.<br /><br />

                예 ) <br />
                홍길동/01012341234/02312/P123445678901<br />
                수취인/01012345678/42101/P123445678922<br />
                .<br />
                .<br />
                에드워드리/01012345678/42101/P123445678922/Edward/Lee<br />
                앤드류정/01012345678/42101/P123445678922/Andrew/Jung<br />
                .<br />
                .
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 초기입력 값
            initText: {
                type: String,
                default: null
            },

            // 초기검색 실행여부
            initCheck: {
                type: Boolean,
                default: false
            },

            // 로그인 ID
            loginUserId: {
                type: Number,
                default: null
            },

            // 로그인 닉네임
            loginUserNick: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                /**
                 * (string) 상태
                 * ready : 입력대기
                 * exec : 처리중
                 * done : 완료
                 */
                state: 'ready',

                /**
                 * (string) 입력값
                 */
                inputText: null,

                /**
                 * (array) 입력배열
                 * 입력문자열을 파싱한결과
                 *
                 * [
                 *      {
                 *          name,
                 *          cell,
                 *          zipcode,
                 *          clearance_no,
                 *          first_name,
                 *          last_name,
                 *          api_state: 개인통관고유부호 api 상태(결과) (ready, ok, fail),
                 *          fail_msg: 실패메세지,
                 *      }
                 * ]
                 */
                inputs: [],


            };
        },
        mounted: function () {
            // 초기검색 실행
            if (_.trim(this.initText) !== '') {
                this.inputText = this.initText;

                if (this.initCheck) {
                    this.check();
                }

            }


        },
        computed: {
            /**
             * 전체 검증결과
             * @return (object) {
             *     result : (string) exec: 처리 및 대기중, correct: 모두일치, has-incorrect: 불일치건 있음, has-no-item: 검색대상이 1건도없음
             *     incorrect_count: 불일치 카운트
             * }
             */
            totalState() {

                // 조회 건수가 0인경우
                if (this.inputs.length < 1) {
                    return {
                        result: 'has-no-item',
                        incorrect_count: 0,
                    };
                }

                let states = _.groupBy(this.inputs, 'api_state');

                if (states.ready) {
                    // 아직 대기중인건이 존재함
                    return {
                        result: 'exec',
                        incorrect_count: 0,
                    };
                }


                if (states.fail) {
                    // 실패건 있음
                    return {
                        result: 'has-incorrect',
                        incorrect_count: states.fail.length,
                    };
                }


                return {
                    result: 'correct',
                    incorrect_count: 0,
                };
            },
        },
        methods: {



            /**
             * 검사 실행
             */
            check () {
                // 입력값 검증
                if (_.trim(this.inputText) === '') {
                    alert('이름/핸드폰/우편번호/개인통관고유부호 를 입력하세요')
                    return;
                }

                // 상태변경
                this.state = 'exec';

                // 입력값 파싱
                let inputs = this.inputText.split('\n');

                // 입력값
                inputs = _.map(inputs, (str) => {
                    str = _.trim(str);

                    // 공백은 무시
                    if (str === '') {
                        return false;
                    }

                    // 이름/번호 파싱
                    // 파싱규칙 : 슬래시, 컴마, 공백(탭포함)
                    let regexp = /([^,\/\s]+)(\s*?[,\/]\s*?|\s+?)([^,\/\s]+?)(\s*?[,\/]\s*?|\s+?)([^,\/\s]+)(\s*?[,\/]\s*?|\s+?)([^,\/\s]+)(\s*?[,\/]\s*?|\s+?)?([^,\/\s]+)?(\s*?[,\/]\s*?|\s+?)?([^,\/\s]+)?/ig;
                    let result = regexp.exec(str);
                    if (! result) {
                        return false;
                    }

                    /*
                    console.log(result);
console.log({
    name: result[1],
    cell: result[3],
    zipcode: result[5],
    clearance_no: result[7],
    first_name: result[9],
    last_name: result[11],
    api_state: 'ready',
});
*/

                    return {
                        name: result[1],
                        cell: result[3],
                        zipcode: result[5],
                        clearance_no: result[7],
                        first_name: result[9],
                        last_name: result[11],
                        api_state: 'ready',
                    };
                });
//console.log(inputs);
                // false 제외
                inputs = _.filter(inputs);
                this.inputs = inputs;

                // 사용자정보
                let user_id = this.loginUserId;
                let user_nick = this.loginUserNick;

                /**
                 * 정상응답 1건에대한 결과처리
                 */
                let resolve_response = (response, obj) => {

                };

                // 프라미스처리로 한건씩 처리
                let promise = new Promise((resolve, reject) => resolve());

                // 하나씩 api 통신
                _.each(this.inputs, (obj) => {

                    // promise 생성
                    promise = promise.then(() => {
                        return new Promise((resolve, reject) => {
                            //reject('failed !');

                            // ajax 옵션
                            let opts = {
                                type: 'post',
                                url: 'https://api.global.gonelo.com/check-clearance-no/ver2026',
                                data: {
                                    //_token: this.csrfToken,
                                    clearance_no: obj.clearance_no,
                                    cell: obj.cell,
                                    name: obj.name,
                                    zipcode: obj.zipcode,
                                    first_name: obj.first_name,
                                    last_name: obj.last_name,

                                    user_id: user_id,
                                    user_nick: user_nick,
                                },
                                success: (response, textStatus, jqXHR) => {
                                    //결과처리
                                    if (response.is_correct) {
                                        obj.api_state = 'ok';
                                    } else {
                                        obj.api_state = 'fail';
                                        obj.fail_msg = response.msg;
                                    }

                                    // 프라미스 처리
                                    resolve();
                                },
                                error: function(jqXHR, textStatus, errorThrown) {
                                    reject(obj);
                                },
                            };

                            // ajax 실행
                            $.app.ajax.module.default(opts);
                        });
                    });

                });

                promise.catch((obj) => {
                    obj.api_state = 'fail';
                    obj.fail_msg = '통신오류';
                });



                // 모든 작업 완료처리
                this.state = 'done';

            },

            /**
             * 다시 입력
             */
            retry () {
                this.state = 'ready';
            },

            /**
             * API 통신상태 텍스트
             * @param obj (object) 입력정보객체
             */
            getApiStateText (obj) {
                if (obj.api_state === 'ok') {
                    return '일치';
                } else if (obj.api_state === 'fail') {
                    return '불일치';
                } else if (obj.api_state === 'ready') {
                    return '-';
                }
                return obj.api_state;
            },

        },
    }
</script>

<style lang="scss" scoped>
    tr.ready {
        td.result {
            color: #999;
        }
    }
    tr.ok {
        td.result {
            color: #0f6ecd;
        }
    }
    tr.fail {
        td.result {
            color: #DE2D2E;
        }
    }

    .total-has-no-item {
        i.material-icons {
            font-size: 2rem;
        }
        text-align: center;
        font-size: 1.5rem;
        color: #999;
    }

    .total-correct {
        i.material-icons {
            font-size: 2rem;
        }
        text-align: center;
        font-size: 1.5rem;
        color: #0f6ecd;
    }

    .total-has-incorrect {
        i.material-icons {
            font-size: 2rem;
        }
        text-align: center;
        font-size: 1.5rem;
        color: #DE2D2E;
    }
</style>